export const BUSINESS = {
  displayName: 'Apex Prestige',
  fullName: 'Apex Prestige Services Extérieurs',
  ownerFirstName: 'Jérémie',
  siteUrl: 'https://www.apexprestige.ca',
  canonicalHostname: 'www.apexprestige.ca',
  phone: '+18195803142',
  phoneDisplay: '(819) 580-3142',
  email: 'apexprestige.services@gmail.com',
  facebook:
    'https://www.facebook.com/share/1Si7jahVVe/?mibextid=wwXIfr',
  availability: 'Sur rendez-vous',
  areaSummary: 'Sherbrooke, Magog, Orford, Bromont et les environs',
} as const;
